module.exports = __webpack_public_path__ + "img/icij-black.e41ca685.svg";